export default "__VITE_ASSET__D86fc2bT__"